const useExport = ({ dispatch, onExport }) => {
  const onExportEnd = (exportType, status = {}) => {
    dispatch({
      type: 'UPDATE_STATE',
      key: 'export',
      state: {
        // a refused request (another download running) ends here too, told apart so the panel can say why
        failed: status.failed || status.busy ? { exportType, busy: Boolean(status.busy) } : null,
        processing: null
      }
    })
  }

  const onExportStart = (exportType, params) => {
    dispatch({
      type: 'UPDATE_STATE',
      key: 'export',
      state: {
        failed: null,
        processing: exportType
      }
    })

    onExport(params, (status = {}) => onExportEnd(exportType, status))
  }

  return { onExportStart }
}

export default useExport
